'use client';

import {useTranslations, useLocale} from 'next-intl';
import Card, {CardBody} from '../ui/Card';

const articles = [1, 2, 3] as const;

const articleImages: Record<number, string> = {
  1: 'article_12316503_900096546726250_2776825374813697637_n.jpg',
  2: 'article_12307437_900578810011357_7519468639371756778_o.jpg',
  3: 'article_a.jpg',
};

export default function NewsSection() {
  const t = useTranslations('news');
  const home = useTranslations('home');
  const locale = useLocale();

  return (
    <section className="py-24 bg-surface relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-primary/20 rounded-full" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          {/* Rose decorative avant le titre */}
          <img
            src="/images/utss/rose.svg"
            alt=""
            aria-hidden="true"
            className="w-[40px] h-[40px] opacity-15 mx-auto mb-4 pointer-events-none select-none"
          />
          <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
            {home('news_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((num) => (
            <Card key={num} hover>
              <div className="aspect-video bg-primary/5 overflow-hidden rounded-t-xl">
                <img
                  src={`/images/utss/${articleImages[num]}`}
                  alt={t(`article_${num}_title`)}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <CardBody className="p-5">
                <div className="text-xs text-primary font-medium mb-2">{t(`article_${num}_date`)}</div>
                <h3 className="text-base font-semibold text-foreground mb-2 line-clamp-2" dir="auto">
                  {t(`article_${num}_title`)}
                </h3>
                <p className="text-muted text-sm line-clamp-2" dir="auto">
                  {t(`article_${num}_desc`)}
                </p>
              </CardBody>
            </Card>
          ))}
        </div>

        <div className="text-center mt-10">
          <a href={`/${locale}/actualites`} className="text-primary font-semibold hover:text-primary-light transition-colors">
            {t('title')} &rarr;
          </a>
        </div>
      </div>
    </section>
  );
}
